/**
 * One day in ms
 */
const dayMs = 1000 * 60 * 60 * 24

module.exports = dayMs
